<div class="search-bar">
  <div class="filter" [formGroup]="searchForm">
    <!-- Ordenação Dropdown -->
    <!-- <p-select appendTo="body" id="sortField" [options]="sortFields" formControlName="sortField" optionLabel="label"
      optionValue="value" placeholder="Ordenar Por" class="w-full md:w-56"></p-select> -->
    <ng-container *ngIf="showFilterBtn">
      <p-button styleClass="secondary-button b-radius-0" (onClick)="filterBtnClick()">
        <ng-container *ngIf="filterBtnIcon; else defaultFilterIcon"><i class="{{ filterBtnIcon }}"></i></ng-container>
        <ng-template #defaultFilterIcon>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </ng-template>
        {{ filterBtnLabel }}
      </p-button>
    </ng-container>

    <ng-container *ngFor="let filter of filters">
      <p-iconfield *ngIf="filter.type === 'text'">
        <p-inputicon styleClass="pi pi-search"></p-inputicon>
        <input [id]="filter.controlName" type="text" pInputText [placeholder]="filter.placeholder"
          [formControlName]="filter.controlName" />
      </p-iconfield>
      <p-select appendTo="body" [id]="filter.controlName" *ngIf="filter.type === 'dropdown'"
        [options]="filter.options || []" [formControlName]="filter.controlName" [optionLabel]="filter.optionLabel"
        [optionValue]="filter.optionValue" [placeholder]="filter.placeholder" class="w-full md:w-56"
        [showClear]="searchForm.get(filter.controlName)?.dirty" clearIcon="pi pi-times" showClear="true"
        [filter]="true"></p-select>
    </ng-container>
  </div>

  <div class="button-container" style="display: flex;gap:5px;">
    <ng-container *ngIf="showPrimaryBtn">
      <p-button styleClass="primary-button" (onClick)="primaryBtnClick()">
        <ng-container *ngIf="primaryBtnIcon; else defaultIcon">{{ primaryBtnIcon }}</ng-container>
        <ng-template #defaultIcon>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </ng-template>
        {{ primaryBtnLabel }}
      </p-button>
    </ng-container>

    <ng-container *ngIf="showSecondBtn">
      <p-button styleClass="secondary-button" (onClick)="secondBtnClick()">
        <ng-container *ngIf="secondBtnIcon">
          <i *ngIf="secondBtnIcon.includes('pi-'); else rawSecondIcon" [class]="secondBtnIcon + ' mr-2'"></i>
          <ng-template #rawSecondIcon>
            <span class="mr-2">{{ secondBtnIcon }}</span>
          </ng-template>
        </ng-container>
        <span>{{ secondBtnLabel }}</span>
      </p-button>
    </ng-container>

    <ng-container *ngIf="showFilterIcon">
      <div class="icon-filter" (Click)="filterIconClick()">
        <ng-container *ngIf="filterIconDisplay; else defaultFilter">{{ filterIconDisplay }}</ng-container>
        <ng-template #defaultFilter>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M3.38589 5.66687C2.62955 4.82155 2.25138 4.39889 2.23712 4.03968C2.22473 3.72764 2.35882 3.42772 2.59963 3.22889C2.87684 3 3.44399 3 4.57828 3H19.4212C20.5555 3 21.1227 3 21.3999 3.22889C21.6407 3.42772 21.7748 3.72764 21.7624 4.03968C21.7481 4.39889 21.3699 4.82155 20.6136 5.66687L14.9074 12.0444C14.7566 12.2129 14.6812 12.2972 14.6275 12.3931C14.5798 12.4781 14.5448 12.5697 14.5236 12.6648C14.4997 12.7721 14.4997 12.8852 14.4997 13.1113V18.4584C14.4997 18.6539 14.4997 18.7517 14.4682 18.8363C14.4403 18.911 14.395 18.9779 14.336 19.0315C14.2692 19.0922 14.1784 19.1285 13.9969 19.2012L10.5969 20.5612C10.2293 20.7082 10.0455 20.7817 9.89802 20.751C9.76901 20.7242 9.6558 20.6476 9.583 20.5377C9.49975 20.4122 9.49974 20.2142 9.49974 19.8184V13.1113C9.49974 12.8852 9.49974 12.7721 9.47587 12.6648C9.45469 12.5697 9.41971 12.4781 9.37204 12.3931C9.31828 12.2972 9.2429 12.2129 9.09213 12.0444L3.38589 5.66687Z"
              stroke="#5A5A5C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </ng-template>
      </div>
    </ng-container>
  </div>
</div>
